// @ts-ignore no types here
import { createHead } from '@unhead/vue'
import { createPinia } from 'pinia'
import { createSSRApp } from 'vue'
import { createI18n } from 'vue-i18n'
import deepmerge from 'deepmerge'

// @ts-ignore no types here
import { setStore } from '@toni/rendering/src/stores/utils/orc-api.js'
import commerceDe from '@toni/commerce-ui/locales/de_DE.json'
import commerceEn from '@toni/commerce-ui/locales/en_EN.json'

import vueApp from './App.vue'
import de from '../../shared/locales/de_DE.json'
import en from '../../shared/locales/en_EN.json'
import { registerDefaultContentBlocks } from '../../components/content-blocks'
import { registerContentBlock } from '../../content-blocks/register-content-block'
// Import intouch specific content block components
import BlockInterline from './components/content-blocks/interline/BlockInterline.vue'
import BlockQuote from './components/content-blocks/quote/BlockQuote.vue'
import BlockTeaserGroup from './components/content-blocks/teaser/BlockTeaserGroup.vue'
import BlockRelatedArticle from './components/content-blocks/related-articles/BlockRelatedArticle.vue'

import type { SSRContext } from '@toni/rendering-tools'

export function createApp (ssrContext?: SSRContext) {
  let app
  if (ssrContext) {
    app = createSSRApp(vueApp, {
      consentConfig: ssrContext.consentConfig,
      config: ssrContext.config,
      url: ssrContext.url,
      brand: ssrContext.brand,
      authorization: ssrContext.Authorization
    })
  } else {
    app = createSSRApp(vueApp)
  }

  const store = createPinia()
  setStore(store)
  app.use(store as any) // suggested by copilot :robot: :clown:

  // Use the configured locale from the brand config
  const configuredLocale = process.env.APP_LOCALE as 'de-DE' | 'en-GB'
  const defaultLocale = configuredLocale.split('-')[0] // 'de' or 'en'

  const i18n = createI18n({
    locale: defaultLocale,
    fallbackLocale: defaultLocale === 'de' ? 'en' : 'de', // fallback to other language
    legacy: false,
    messages: {
      de: deepmerge(de, commerceDe),
      en: deepmerge(en, commerceEn)
    }
  })
  app.use(i18n)
  const head = createHead()
  app.use(head)

  // Register content block components
  registerDefaultContentBlocks()

  // Register intouch content block components
  registerContentBlock('interline', BlockInterline)
  registerContentBlock('quote', BlockQuote)
  registerContentBlock('teaserGroup', BlockTeaserGroup)
  registerContentBlock('__injected_related__', BlockRelatedArticle)

  return { app, store, head }
}
